import { Component } from '@angular/core';
import { TransferHttpService } from '../../../services/transfer-http/transfer-http.service';
import { Router } from '@angular/router';

import { PermissionsService } from '../../../services/permissions/permissions.service';
import { TrainingFunctions } from '../functions/trainingFunctions';
import { AimsHub } from '../../../components/aimsHub/aimsHub';
import { HrEmployees } from '../../../../models';
import { QualHistory } from '../training/trainingCommon';
import { AimsCommonPopupEditorComponent, AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions } from '@aims/common-components';
import { MatDialog } from '@angular/material/dialog';
import { RevokeCommentDialogComponent } from '../training/revoke-comment-dialog/revoke-comment-dialog.component';

@Component({
  selector: 'qualApproval',
  templateUrl: './trainingApproval.component.html',
  styleUrls: ['../hr.component.css'],
  providers: [TrainingFunctions, AimsHub]
})

export class QualApprovalQueueComponent {

  constructor(private transferHttp: TransferHttpService,
    private router: Router,
    private dialog: MatDialog,
    public permissions: PermissionsService,
    public qualApprovalHub: AimsHub) { }

  public tablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
  };
  public tableHeader: AimsCommonTableHeader[] = [
    { key: 'rowExpand', label: '', type: 'rowExpand', filter: false },
    { key: 'button', label: '', type: 'dynamic', filter: false, width: 175 },
    { key: 'employee', label: 'Employee', type: AimsCommonTableHeaderType.STRING },
    { key: 'qualDesc', label: 'Qualification', type: AimsCommonTableHeaderType.STRING },
    { key: 'qualNotRequired', label: 'Required', type: AimsCommonTableHeaderType.DYNAMIC,
            events: { filterAndSort: (element) => !element.qualNotRequired }, filterType: AimsCommonTableFilterType.BOOLEAN, width: 80 },
    { key: 'qualOwner', label: 'Qual Owner', type: AimsCommonTableHeaderType.STRING },
    { key: 'qualOwnerDeptId', label: 'Qual Owner Dept', type: AimsCommonTableHeaderType.DYNAMIC, filterType: AimsCommonTableFilterType.DYNAMIC },
  ];

  public subTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
  };
  public subTableHeader: AimsCommonTableHeader[] = [
    { key: 'button', label: '', type: 'dynamic', filter: false, width: 175 },
    { key: 'qtDesc', label: 'Qual Task Desc', type: AimsCommonTableHeaderType.STRING },
    { key: 'intervalInMonths', label: 'Interval In Months', type: AimsCommonTableHeaderType.NUMBER },
    { key: 'qtNotRequired', label: 'Required', type: AimsCommonTableHeaderType.DYNAMIC,
            events: { filterAndSort: (element) => !element.qtNotRequired}, filterType: AimsCommonTableFilterType.BOOLEAN, width: 80 },
    { key: 'revoked', label: 'Revoked', type: AimsCommonTableHeaderType.BOOLEAN, width: 80 },
    { key: 'completedOn', label: 'Completed On', type: AimsCommonTableHeaderType.DATE },
    { key: 'trainedBy', label: 'Trained By', type: AimsCommonTableHeaderType.STRING },
    { key: 'certifiedBy', label: 'Certified By', type: AimsCommonTableHeaderType.STRING },
  ];

  user = this.transferHttp.getCache<HrEmployees>('user');
  empId = this.user.employeeId;

  routedFrom = 'qualApproval';
  headerText = "Qual Approval Queue";

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  showAllFromMyDept: boolean = false;
  showAllDepts: boolean = false;

  revokeCommentTxt: string = null;
  sendRevokeEmail: boolean = false;

  qId: number = 0;
  qthId: number = 0;
  qthDesc: string = null;
  qthLoginName: string = null;
  rowIndex: number = null;

  //Dropdowns
  qualValues = this.transferHttp.getHot('Tr/GetQualificationsForDropDown');
  departmentValues = this.transferHttp.getHot('Common/GetAllDepartmentsForDropdown');

  //Grid
  public allQualsAwaitingApproval: Array<any>;
  public qualsAwaitingApproval : Array<any>;

  public handleShowAllFromMyDept() {
    if (this.showAllFromMyDept) {
      this.showAllDepts = false;
      this.headerText = "Qual Approval Queue -- All in my Department";
    }
    else {
      this.showAllDepts = false;
      this.showAllFromMyDept = false;
      this.headerText = "Qual Approval Queue";
    }

    this.applyFilter();
  }

  public handleShowAllDepts() {
    if (this.showAllDepts) {
      this.showAllFromMyDept = false;
      this.headerText = "Qual Approval Queue -- All";
    }
    else {
      this.showAllDepts = false;
      this.showAllFromMyDept = false;
      this.headerText = "Qual Approval Queue";
    }

    this.applyFilter();
  }

  //Revoke Comment
  public openRevokeComment(trainingHistory: any, rowIndex: number) {
    this.rowIndex = rowIndex;
    this.qId = trainingHistory.qualId;
    this.qthId = trainingHistory.qtHistoryId;
    this.qthDesc = trainingHistory.qtDesc;
    this.qthLoginName = trainingHistory.loginName;
    this.sendRevokeEmail = true;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      width: '500px',
      data: {
        header: '',
        content: RevokeCommentDialogComponent,
        contentData: { qthDesc : this.qthDesc,
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.revokeCommentTxt = dialogResult.revokeComment;
        this.sendRevokeEmail = dialogResult.sendRevokeEmail;

        this.doRevoke();
      }
      else {
        this.cancelRevokeComment();
      }
    });
  }

  public cancelRevokeComment() {
    this.revokeCommentTxt = null;
  }

  public doRevoke() {
    let today = new Date();
    let revokedOn = today.toDateString();
    let revokedBy = this.user.fullName;
    let revokeComment = this.revokeCommentTxt;
    this.spinnerText = "Revoking...";
    this.showSpinner = true;

    this.transferHttp.get(`Tr/RevokeTraining?qId=${this.qId}&qthId=${this.qthId}&revokedReason=${this.revokeCommentTxt}`).subscribe(retVal => {
      if (this.sendRevokeEmail) {
        this.transferHttp.get(`Tr/SendRevokeEmail?desc=${escape(this.qthDesc)}&revokedOn=${revokedOn}&revokedBy=${revokedBy}&revokedReason=${revokeComment}&loginName=${this.qthLoginName}`).subscribe();
      }

      this.refreshData();
      this.showSpinner = false;
    });

    this.revokeCommentTxt = null;
  }

  public approveQualificaiton(qual: any, rowIndex: number) {
    var qualHistory = new QualHistory();
    qualHistory.qualId = qual.qualId;
    qualHistory.qualHistoryId = qual.qualHistoryId;
    qualHistory.employeeId = qual.employeeId;
    qualHistory.approvedById = this.empId;
    qualHistory.approvedOn = new Date();
    qualHistory.revokedById = null;
    qualHistory.revokedOn = null;

    this.spinnerText = "Approving Qualification...";
    this.showSpinner = true;

    this.transferHttp.post(`Tr/SaveQualHistory`, qualHistory).subscribe(retVal => {
      this.refreshData();

      this.showSpinner = false;
    });
  }

  public updateQualRequired(qual: any) {
    this.spinnerText = "Updating Qual required...";
    this.showSpinner = true;

    if (qual.qualNotRequired) {
      this.transferHttp.delete(`Tr/DeleteQualNotRequired?qualId=${qual.qualId}&empId=${qual.employeeId}`).subscribe(show => {
        this.showSpinner = false;
        this.refreshData();
      });
    }
    else {
      this.transferHttp.post(`Tr/SaveQualNotRequired?qualId=${qual.qualId}&empId=${qual.employeeId}`, null).subscribe(show => {
        this.showSpinner = false;
        this.refreshData();
      });
    }
  }

  public updateQtRequired(qt: any) {
    this.spinnerText = "Updating Qual Task required...";
    this.showSpinner = true;

    if (qt.qtNotRequired) {
      this.transferHttp.delete(`Tr/DeleteQtNotRequired?qualTaskId=${qt.qualTaskId}&empId=${qt.employeeId}`).subscribe(show => {
        this.showSpinner = false;
        this.refreshData();
      });
    }
    else {
      this.transferHttp.post(`Tr/SaveQtNotRequired?qualTaskId=${qt.qualTaskId}&empId=${qt.employeeId}`, null).subscribe(show => {
        this.showSpinner = false;
        this.refreshData();
      });
    }
  }

  applyFilter() {
    if (this.showAllFromMyDept) {
      this.qualsAwaitingApproval = this.allQualsAwaitingApproval.filter(t => t['qualOwnerDeptId'] == this.user.departmentId);
    }
    else if (this.showAllDepts) {
      this.qualsAwaitingApproval = this.allQualsAwaitingApproval;
    }
    else {
      this.qualsAwaitingApproval = this.allQualsAwaitingApproval.filter(t => t['qualOwner'] == this.user.fullName);
    }
  }

 refreshData() {
    this.showSpinner = true;
    this.qualApprovalHub.getHot('qualApprovals').subscribe(ret => {
      this.showSpinner = false;
      this.allQualsAwaitingApproval = ret;
      this.applyFilter();
    });
  }

  //***************************
  // Init
  //***************************
  ngOnInit(): void {
    this.refreshData();
  }

}
